import React, {useReducer} from 'react'
import reducer, { setState } from '../utils/CommonReducer'
import AnPopup from "../cta_utils/AnPopup"
import Icon from '../utils/Icon'
const FlagDetails = ({
    post,
    ...props
}) => {
    const [componentState, setComponentState] = useReducer(reducer, {
        popupsList: {}
    })
    const {popupsList} = componentState;

    const detailsPopup = () => {
        return(
            <>
                <AnPopup maxWidth="480px" name="detailsPopup" handleOnClosePopup={() => setState(setComponentState)({popupsList: {}})}>
                {/* <AnPopup maxWidth="480px" name="detailsPopup" handleOnClosePopup={() => console.log("This iss ittt")}> */}
                    <div className="text_title">
                        Flagged Article
                    </div>
                    <div  className="line_seperator_ex_light_grey" style={{ margin: "16px auto" }}></div>
                    <div>
                        <span className="text_body_light">Flagged by: <span className="text_body">{post.flagged_by}</span> on <span className="text_body">{post.flagged_at}</span></span>
                    </div>
                    <div style={{marginTop: 8}}>
                        <span className="text_body_light">Comments: <span className="text_body">{post.flagged_reason}</span></span>
                    </div>
                </AnPopup>
            </>
        )
    }
    return (
        <>
            <div className={(post.flagged_by ? "icon_box_container" : "icon_box_container_hover") + " flex_center"} style={{marginLeft: "8px", width: 36, height: 36}}
                onClick={() => {
                    setState(setComponentState)({popupsList: {detailsPopup: true}})
                }}
            >
                <Icon name="FlagGreyFill"></Icon>
            </div>
            {popupsList.detailsPopup && detailsPopup()}
        </>
    )
}

export default FlagDetails